"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const QuickActionsBar = _ref => {
  let {
    links,
    title
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-actions-bar"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "qab--title"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "qab--btns"
  }, links.map((link, index) => /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: link.href,
    className: "button is-primary",
    key: index
  }, link.text))));
};
QuickActionsBar.propTypes = {
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    href: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired
  })).isRequired,
  title: _propTypes.default.string.isRequired
};
var _default = exports.default = (0, _CoreProps.withUiProps)(QuickActionsBar);
//# sourceMappingURL=QuickActionsBar.js.map